import React from "react"

import { renderedListingSourceType } from "../../../../config/application-definitions"
import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import RelatedInsightAreasViewWidget from "../../../common/RelatedInsightAreasViewWidget"
import SourceViewItemDetails from "./SourceViewItemDetails"
import SourceViewRenderedListingDetails from "./SourceViewRenderedListingDetails"
import SourceViewItemClassificationDetails from "./SourceViewItemClassificationDetails"
import SourceViewErrorDetails from "./SourceViewErrorDetails"

const SourceViewItem = ({ model, isFetching }) => (
    <ItemDetailsColumns className="item-container">
        <ItemDetailsColumn>
            <SourceViewItemDetails
                name={model.name}
                url={model.url}
                description={model.description}
                active={model.active}
                favicon={model.favicon}
                isFetching={isFetching}
            />
            {model.type === renderedListingSourceType && (
                <SourceViewRenderedListingDetails
                    url={model.url}
                    linkPattern={model.link_pattern}
                    listingUrls={model.listing_urls}
                    isFetching={isFetching}
                />
            )}
            <RelatedInsightAreasViewWidget
                relatedTopics={model.topics}
                isFetching={isFetching}
            />
            {model.source_request_error_count ? (
                <SourceViewErrorDetails
                    sourceRequestErrorCount={model.source_request_error_count}
                />
            ) : null}
        </ItemDetailsColumn>
        <ItemDetailsColumn>
            <SourceViewItemClassificationDetails
                type={model.type}
                lastImportTime={model.updated}
                preserveArticleLinks={model.preserve_article_links}
                publicationType={model.publication_type}
                contentType={model.content_type}
                country={model.country}
                region={model.region}
                language={model.language}
                license={model.license}
                autoApproved={model.auto_approved}
                isFetching={isFetching}
            />
        </ItemDetailsColumn>
    </ItemDetailsColumns>
)

export default SourceViewItem
